import '../assets/NcAppSettingsSection-Dq0eTGEp.css';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { u as useAppSettingsDialog } from "./useAppSettingsDialog-Dn48dw1k.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = {
  name: "NcAppSettingsSection",
  props: {
    /**
     * Name of the section
     */
    name: {
      type: String,
      required: true
    },
    /**
     * The id of the section
     */
    id: {
      type: String,
      required: true,
      validator(id) {
        return /^[a-z0-9\-_]+$/.test(id);
      }
    }
  },
  setup() {
    return __spreadValues({}, useAppSettingsDialog());
  },
  computed: {
    // generate an id for each settingssection based on the name without whitespaces
    htmlId() {
      return "settings-section_" + this.id;
    }
  },
  // Reactive changes for section navigation
  watch: {
    id(newId, oldId) {
      var _a;
      this.unregisterSection(oldId);
      this.registerSection(newId, this.name, (_a = this.$slots) == null ? void 0 : _a.icon);
    },
    name(newName) {
      var _a;
      this.unregisterSection(this.id);
      this.registerSection(this.id, newName, (_a = this.$slots) == null ? void 0 : _a.icon);
    }
  },
  mounted() {
    var _a;
    this.registerSection(this.id, this.name, (_a = this.$slots) == null ? void 0 : _a.icon);
  },
  beforeDestroy() {
    this.unregisterSection(this.id);
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("section", { staticClass: "app-settings-section", attrs: { "id": _vm.htmlId, "aria-labelledby": "".concat(_vm.htmlId, "--label") } }, [_c("h3", { staticClass: "app-settings-section__name", attrs: { "id": "".concat(_vm.htmlId, "--label") } }, [_vm._v(" " + _vm._s(_vm.name) + " ")]), _vm._t("default"), _vm._e()], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "caabd323"
);
const NcAppSettingsSection = __component__.exports;
export {
  NcAppSettingsSection as N
};
//# sourceMappingURL=NcAppSettingsSection-BNVlt4g0.mjs.map
